// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-vantage -> price-brothers-vantage -> wind-river-lodge-apartments-townhomes
// Generated: 2026-11-03T22:58:03.080Z
// Counts: 0 design, 67 content, 11 slot group, 2 collection binding, 8 section, 1 style

export const designOverrides = {};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_address_city\"></span> Apartments For Rent</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Inclusive access for every visitor</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Comfort and convenience at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply for <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom apartments at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reach our leasing team today</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Contact Us</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Answers to the questions residents ask most at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom apartments for rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.lets_talk_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Your New <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span> Apartment is Waiting</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>See life at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Gallery</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Explore the <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span> Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Neighborhood</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-friendly living at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 14px;\">Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive move-in savings at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Program Benefits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for </h2><h2>Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Preferred Employers</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>How we protect your information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.grid_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pay rent and manage your account</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident stories from <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Visit <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Schedule A Tour</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Each Price Brothers Management Co. community has its own character, amenities, and floor plans. Explore the options above to find the one that feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Nearby Communities From the Price Brothers Management Co.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate every page on <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "studios-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Studio Floor Plans at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We'll be in touch soon</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Tour Our <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom apartments at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Virtual Tours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><strong>Connected Lenexa, with green space close by.</strong> Wind River Lodge Apartments &amp; Townhomes puts highways, the 95th Street corridor, and Lenexa City Center within easy reach. Grab coffee, browse local dining, catch community events, or sample rotating flavors at Lenexa Public Market—then unwind at City Center Park or Sar-Ko-Par Trails Park with pond paths, disc golf, courts, and gardens nearby.</p>",
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "preferredemployerlist.employers": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Kiewit</p></li><li><p>Cerner</p></li><li><p>Hyland Software</p></li><li><p>Quest Diagnostic</p></li><li><p>Garmin</p></li><li><p>Geico</p></li><li><p>Firefighters</p></li><li><p>Police Officers/State Troopers</p></li><li><p>Amazon</p></li><li><p>Honeywell</p></li><li><p>Active Military</p></li><li><p>All Price Brothers Commercial Tenants</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "multihub-lead-form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "hero.rail_schedule": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "custom_self_guided_tour_url",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "scheduletourform.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167625/01a0b67a-cd5f-70de-aa1a-87171691a8f8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resort-style pool with lounge chairs and a covered cabana."
      }
    }
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a Price Brothers sister apartment community"
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a Price Brothers sister apartment community"
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a Price Brothers sister apartment community"
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a Price Brothers sister apartment community"
      }
    }
  },
  "sisterproperties.community5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a Price Brothers sister apartment community"
      }
    }
  },
  "sisterproperties.community6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a Price Brothers sister apartment community"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.amenities": {
    "limit": 8,
    "hiddenIds": null,
    "orderedIds": [
      "ec_5d2bdf41b3214ba57e1d58ef",
      "ec_a15c10f6ec58462e95ce3798",
      "ec_1bdcbd0019794f1583635984",
      "ec_6217700c0ca08dbc2a11d6c1",
      "ec_eb9ff2fd44addced8b4a1d87",
      "ec_fbdb4562ac8f160ab39bfe0f",
      "ec_782dbd69ffbf52e982954161",
      "ec_b3ee2a1525c06bf650c633aa",
      "ec_0266124e06d35e8338127e11",
      "ec_de949c75baa1226462c652bb",
      "ec_ff95608ef9003a807aa972d4",
      "ec_eae793fea7e7eb8af23e5a12",
      "ec_50fe19cce72059e82b94e781",
      "ec_2059607a3ebe49260ee2e1dc",
      "ec_74166dc155df348c8215eaa4",
      "ec_c6f3a54e3068fcb9769034cf",
      "ec_007ee37e96bcf125c626fe89",
      "ec_d6b7a5fc4f152f08aa908bcb",
      "ec_e876df09e32aeaf45760dc4f",
      "ec_5716c3e97f1d458eeb827d2d",
      "ec_f83a8dc2d9bb9c5bfb236b0e",
      "ec_c16950966439680dd377ab23",
      "ec_461f116336b33a59bf6df72c",
      "ec_8b69230ddd645873535cbaf5",
      "ec_6a477e7b36e46d6273f5cf34",
      "ec_be941970e710a725e9deb3c5",
      "ec_7084621987b6b4fc762ebcaf",
      "ec_39a31642d451c080eb307412"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "photogallery.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_0ea804bc0b84ad15befdef85",
      "ec_b71965b1febadd70232df1be",
      "ec_8bf087d74605ac3a572d3698",
      "ec_c38cd1aebaf47ad7e76fd8dd",
      "ec_81ebacaf1c29a1d0276dc6b1",
      "ec_5202edaa7f7b1ae5d8228046",
      "ec_a155691b0c3eb2b027a366bb",
      "ec_12efc29501d4318506937fb1",
      "ec_ed44b4733da4ca6e36ee086a",
      "ec_815ddafebe83ce75198b2728",
      "ec_552faa59e919ada3610234c3",
      "ec_276bf66cb65c5deb51a245f5",
      "ec_25a6117eebaaaa9864a658b1",
      "ec_5841aacf2815a38a5125f675",
      "ec_9c5735150cb81e6a1e8081a9",
      "ec_9617041628269ea8f5a63d9c",
      "ec_55caab5c7474d83219957c03",
      "ec_eadca0737baf6dc60c51b1ef",
      "ec_7366e61a29e74a44ca559818",
      "ec_11c9296fb475c306b0b409e8",
      "ec_c561c5fec716496778d3d822",
      "ec_d9b5d448504d2fe3d71a671e",
      "ec_db89f37eac5f7c93a2f398c2",
      "ec_ddb3e5386d5f423d970ba60c",
      "ec_b35d32d1369ba8673c55a957",
      "ec_1462ec8848d6bf9dfe47c884",
      "ec_d85a749cc24b01cd5df7ebbd",
      "ec_e44d525f6f1855321f736652",
      "ec_28788c278ad771661a1dc1ca",
      "ec_beb135a4d8474a8cbe19f2e0",
      "ec_1c07ca8f7567ab0945cab257",
      "ec_761aa07ed71123c01e5d41d0",
      "ec_7b856d05b141d97b6f621227",
      "ec_1e8adf053a48d4f0f004ab52",
      "ec_be671637ed215155c8fb508f",
      "ec_ca41fe3858dd676f700f2600",
      "ec_9c2c353eebcb5257d0e55f22",
      "ec_f97adb7fd86c94d8f6fc888a",
      "ec_4b149c5c4bc1c8d2902632ec",
      "ec_bb0dcbbf1adae9194c170e30",
      "ec_7512cc0c358b999fff33d05a",
      "ec_4875d694a1de3504d556fc0b",
      "ec_72c418c9d131114029805104",
      "ec_d54e18f2cdffd8c873eeb21b",
      "ec_a1af35fe021c2e658d434245",
      "ec_7fadfdc5e4d299ae8a2f66c0",
      "ec_e24ec096ba762c78db8e79ef",
      "ec_2da0045d01015d7b5dbc78e3"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  }
};
